// SubAccount Module Initialization
// This file contains all side effects for the subaccount module.
// It is imported by src/imports.ts at application startup.

import './subAccount.service'
import './subaccount.commands'

import {
    CUSTOMERS,
    SUPPLIERS,
    SUBACC_DETAILS,
    ACCOUNTS_RECEIVABLE,
    ACCOUNTS_PAYABLE,
    SACC_IMPORT,
    CUSTOMER_AGE_DIVIDED_REPORT,
    SUPPLIER_AGE_DIVIDED_REPORT
} from '@/subaccount'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'
import { usePanelManager } from '@tritt/multipanel'
import { h } from 'vue'
import SubAccountCrumb from '@/subaccount/SubAccountCrumb.vue'
import { NavGroup, registerNavigationEntry } from '@/navigation'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb, registerBreadCrumbGetter } = useBreadCrumbs()

// CUSTOMERS
const customers_label = 'Kunder'
const customers_icon = 'i-ph-users-three-fill'
registerRoute(CUSTOMERS)
registerNavigationCommand({
    route: CUSTOMERS,
    label: customers_label,
    icon: customers_icon,
})
registerNavigationEntry(NavGroup.MISC, {
    title: customers_label,
    key: 'customers',
    icon: customers_icon,
    target: CUSTOMERS,
    sortOrder: 0
})
buildSimpleCrumb(CUSTOMERS, customers_label, customers_icon)

// SUPPLIERS
const suppliers_label = 'Leverandører'
const suppliers_icon = 'i-ph-truck-fill'
registerRoute(SUPPLIERS)
registerNavigationCommand({
    route: SUPPLIERS,
    label: suppliers_label,
    icon: suppliers_icon
})
registerNavigationEntry(NavGroup.MISC, {
    title: suppliers_label,
    key: 'suppliers',
    icon: suppliers_icon,
    target: SUPPLIERS,
    sortOrder: 1
})
buildSimpleCrumb(SUPPLIERS, 'Leverandører', 'i-ph-truck-fill')

// SUBACC_DETAILS
registerRoute(SUBACC_DETAILS)
registerBreadCrumbGetter(() => {
    const { currentPanelContent } = usePanelManager()
    if (currentPanelContent.value?.componentName !== SUBACC_DETAILS.componentName) {
        return
    }
    return h(SubAccountCrumb, {
        subAccountUuid: currentPanelContent.value?.props.subAccountUuid
    })
})

// ACCOUNTS_RECEIVABLE
registerRoute(ACCOUNTS_RECEIVABLE)
registerNavigationCommand({
    route: ACCOUNTS_RECEIVABLE,
    label: 'Kundereskontro',
    icon: 'i-ph-money-fill',
    hotkey: 't'
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: 'Kundereskontro',
    key: 'accounts-receivable',
    icon: 'i-ph-money-fill',
    target: ACCOUNTS_RECEIVABLE,
    sortOrder: 7
})
buildSimpleCrumb(ACCOUNTS_RECEIVABLE, 'Kundereskontro', 'i-ph-money-fill', true)

// ACCOUNTS_PAYABLE
registerRoute(ACCOUNTS_PAYABLE)
registerNavigationCommand({
    route: ACCOUNTS_PAYABLE,
    label: 'Leverandørreskontro',
    icon: 'i-ph-money-fill',
    hotkey: 'y'
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: 'Leverandørreskontro',
    key: 'accounts-payable',
    icon: 'i-ph-money-fill',
    target: ACCOUNTS_PAYABLE,
    sortOrder: 8
})
buildSimpleCrumb(ACCOUNTS_PAYABLE, 'Leverandørreskontro', 'i-ph-money-fill', true)

// SACC_IMPORT
registerRoute(SACC_IMPORT)
registerNavigationCommand({
    route: SACC_IMPORT,
    label: 'Importer kunder og leverandører',
    icon: 'i-ph-user-plus-fill'
})
registerNavigationEntry(NavGroup.IMPORTS, {
    title: 'Importer kunder / leverandører',
    key: 'sacc-import',
    icon: 'i-ph-users-three-fill',
    target: SACC_IMPORT,
    sortOrder: 2
})
buildSimpleCrumb(SACC_IMPORT, 'Importer kunder og leverandører', 'i-ph-user-plus-fill', true)

// CUSTOMER_AGE_DIVIDED_REPORT
registerRoute(CUSTOMER_AGE_DIVIDED_REPORT)
registerNavigationCommand({
    route: CUSTOMER_AGE_DIVIDED_REPORT,
    label: 'Aldersfordelt kundereskontro',
    icon: 'i-ph-users-three-fill'
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: 'Aldersfordelt kundereskontro',
    key: 'customer-age-divided-report',
    icon: 'i-ph-users-three-fill',
    target: CUSTOMER_AGE_DIVIDED_REPORT,
    sortOrder: 9
})
buildSimpleCrumb(CUSTOMER_AGE_DIVIDED_REPORT, 'Aldersfordelt kundereskontro', 'i-ph-users-three-fill', true)

// SUPPLIER_AGE_DIVIDED_REPORT
registerRoute(SUPPLIER_AGE_DIVIDED_REPORT)
registerNavigationCommand({
    route: SUPPLIER_AGE_DIVIDED_REPORT,
    label: 'Aldersfordelt leverandørreskontro',
    icon: 'i-ph-truck-fill'
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: 'Aldersfordelt leverandørreskontro',
    key: 'supplier-age-divided-report',
    icon: 'i-ph-truck-fill',
    target: SUPPLIER_AGE_DIVIDED_REPORT,
    sortOrder: 10
})
buildSimpleCrumb(SUPPLIER_AGE_DIVIDED_REPORT, 'Aldersfordelt leverandørreskontro', 'i-ph-truck-fill', true)
